import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBBCfs-_vl1C9pPpbdP6N12PRvnIR1IOKM",
  authDomain: "skillsprint-f7d51.firebaseapp.com",
  projectId: "skillsprint-f7d51",
  storageBucket: "skillsprint-f7d51.firebasestorage.app",
  messagingSenderId: "790833063908",
  appId: "1:790833063908:web:d0dd9c6f175779e89789f1",
  measurementId: "G-7SRZWFZ75L"
};

let app;
let auth;
let db;
let isInitialized = false;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  isInitialized = true;
  console.log('Firebase initialized successfully');
} catch (error) {
  console.error('Error initializing Firebase:', error);
}

export { app, auth, db, isInitialized };